import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Box, Divider, Typography } from "@mui/material";
import { configButtonsConditioning } from "../utils/constants";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { MButton, ResponsiveFormContainer } from "@app/components";

interface ConditioningFormProps {
  mode: MODES_OPTIONS;
}

const ConditioningForm = ({ mode }: ConditioningFormProps) => {
  const [phaseSelected, setPhaseSelected] = useState<string>("results");
  const form = useFormContext();

  const reportType = form.watch("reportType");

  useEffect(() => {
    if (!reportType) {
      form.setValue(
        "reportType",
        configButtonsConditioning[phaseSelected].type
      );
    }
  }, [phaseSelected]);

  const changePhase = (phase: string) => {
    setPhaseSelected(phase);
    form.setValue("reportType", configButtonsConditioning[phase].type);
    // Limpiar tipos de análisis al cambiar de tipo de informe,
    // ya que cada formulario maneja este campo de forma diferente
    form.setValue("reporte_tipos_analisis", []);
  };

  const CurrentForm =
    configButtonsConditioning[reportType || phaseSelected].component;

  return (
    <ResponsiveFormContainer columns={1}>
      <Typography variant="tagText">
        {"Selecciona el tipo de informe a generar:"}
      </Typography>
      <Box display="flex" justifyContent="center">
        {Object.keys(configButtonsConditioning).map((key) => (
          <MButton
            key={key}
            variant={phaseSelected === key ? "contained" : "outlined"}
            color="secondary"
            sx={{ ml: 2 }}
            text={configButtonsConditioning[key].title}
            fullWidth
            onClick={() => changePhase(key)}
            disabled={
              (mode === MODES_OPTIONS.EDIT ||
                mode === MODES_OPTIONS.VIEW ||
                mode === MODES_OPTIONS.COPY) &&
              configButtonsConditioning[key].type !== reportType
            }
          />
        ))}
      </Box>
      <Divider />
      <Box p={2}>
        <CurrentForm mode={mode} />
      </Box>
    </ResponsiveFormContainer>
  );
};

export default ConditioningForm;
